<template>
	<div data-align="center" class="quote-game-cont intruder-game stack-vertical" data-justify="center">
		<div v-if="showOnlyIntro && !isMobile" class="quote-game-board-cont stack-vertical" data-align="center">
			<div class="quote-game-board game-intro-section stack-vertical small-radius relative">
				<p class="font-paragrafo-scrolly">{{description ? description : $t('game_descrizione_intruso')}}</p>
			</div>
			<base-button type="variant4" :fit-width="isMobile" :text="utils.capitalizeFirst($t('game_inizia'))" @clicked="() => showOnlyIntro = false"/>
		</div>
		<div v-if="showOnlyIntro && isMobile" class="quote-game-board-cont game-quiz-intro relative stack-vertical" data-justify="spaced">
			<div class="stack-horizontal result-parenthesis parenthesis-intro" data-align="center">
				<base-icon name="left-parenthesis"/>
				<div class="section-button-text stack-vertical" data-align="center">
					<p class="capitalize-first">{{description ? description : $t('game_descrizione_intruso')}}</p>
				</div>
				<base-icon name="right-parenthesis"/>
			</div>
			<base-button type="variant4" :fit-width="isMobile" :text="utils.capitalizeFirst($t('game_inizia'))" @clicked="() => showOnlyIntro = false"/>
		</div>
		<!-- ACTUAL GAME -->
		<div v-if="!showOnlyIntro" class="quote-game-board-cont stack-vertical" data-align="center">
			<div class="quote-game-board game-quiz-board stack-vertical small-rounded relative">
				<div :class="`game-result-modal abs-fill stack-vertical small-rounded ${showResultModal ? 'visible' : ''}`" data-justify="center" data-align="center">
					<div v-if="result" class="stack-horizontal result-parenthesis good-result" data-align="center">
						<base-icon name="left-parenthesis"/>
						<div class="section-button-text stack-vertical" data-align="center">
							<h3 class="capitalize-first">{{resultText}}</h3>
						</div>
						<base-icon name="right-parenthesis"/>
					</div>
					<div v-else class="stack-vertical result-parenthesis wrong-result" data-align="center">
						<base-icon name="top-parenthesis"/>
						<div class="section-button-text stack-vertical" data-align="center">
							<h3 class="capitalize-first">{{resultText}}</h3>
						</div>
						<base-icon name="bottom-parenthesis"/>
					</div>
					<div class="full-answer-text font-paragrafo full-width">{{currentQuery.fullAnswer[$i18n.locale]}}</div>
					<img class="result-img machiavelli-img" :src="machiavelliImg">
					<img class="result-img dante-img" :src="danteImg">
				</div>
				<div :class="`game-result-modal game-over abs-fill stack-vertical small-rounded ${showGameOverModal ? 'visible' : ''}`" data-justify="center" data-align="center">
					<div class="game-over-modal-contents stack-vertical" data-align="center">
						<div class="stack-horizontal result-parenthesis game-over" data-align="center">
							<base-icon name="left-parenthesis"/>
							<div class="section-button-text stack-vertical" data-align="center">
								<h3 class="capitalize-first">{{gameOverText[$i18n.locale]}}</h3>
							</div>
							<base-icon name="right-parenthesis"/>
						</div>
						<!-- <h3 class="game-attempts-text capitalize-first">{{numAttemptsText[$i18n.locale]}}</h3> -->
						<!-- <h3 class="game-attempts-text capitalize-first">{{attemptsCounter}}</h3> -->
						<h3 class="game-attempts-text">{{attemptsCounter}}/{{gameContents.length}}</h3>
						<div></div>
						<img class="result-img horse-img" :src="horseImg">
					</div>
				</div>
				<div class="game-quiz-cont stack-vertical">
					<div class="game-quiz-quote-text font-paragrafo-scrolly capitalize-first">{{currentQuery.fullQuery[$i18n.locale]}}</div>
					<div class="game-quiz-answers-cont stack-vertical">
						<button v-for="answer in currentQuery.answers" :class="{selected: answer.selected, 'wrong-answer': answer.selected && !answer.correct}" class="game-quiz-answer small-radius font-paragrafo" @click="chooseAnswer(answer.id)">{{utils.capitalizeFirst(answer.text[$i18n.locale])}}</button>
					</div>
				</div>
			</div>
			<Transition name="opacity-appear">
				<base-button v-if="showProceedBtn" type="variant4" :fit-width="isMobile" :text="utils.capitalizeFirst(btnProceedText)" @clicked="proceed" />
			</Transition>
			<Transition name="opacity-appear">
				<base-button v-if="showRestartBtn" type="variant4" :fit-width="isMobile" :text="utils.capitalizeFirst(tryAgainText[$i18n.locale])" @clicked="resetGame" />
			</Transition>
		</div>
	</div>
</template>

<script type="text/javascript">
	
import cloneDeep from 'lodash.clonedeep';
import remove from 'lodash.remove';
import shuffle from 'lodash.shuffle';
import { documentToSVG, elementToSVG, inlineResources, formatXML } from 'dom-to-svg';
import utils from '@js/utils.js'
import { nextTick, Transition } from 'vue';
import { mapGetters } from 'vuex';

export default {
	name: 'InterfaceQuoteGame',
	props: {
		gameContents: {
			type: Array,
			default: []
		},
		title: {
			type: String,
		},
		description:{
			type: String,
		}
	},
	data() {
		return {
			utils,
			showResultModal: false,
			showGameOverModal: false,
			showProceedBtn: false,
			showOnlyIntro: true,
			showRestartBtn: false,
			introButtonText: {
				it: 'inizia',
				en: 'start'
			},
			nextButtontext: {
				it: "prossima",
				en: "next",
			},
			sendButtonText: {
				it: "invia",
				en: "send"
			},
			shareButtonText: {
		 		it: "condividi",
				en: "share"
			},
			chooseWordButtonText: {
				it: "scegli parola",
				en: "choose word"
			},
			guessedQuoteOwner: '',
			completeQuoteText: {
				it: 'completa la citazione',
				en: 'complete the quote'
			},
			tryAgainText: {
				it: "riprova",
				en: "try again"
			},
			nextQueryText: {
				it: "prossima domanda",
				en: "next question"
			},
			gameOverText: {
				it: "complimenti",
				en: "congratulations"
			},
			numAttemptsText: {
				it: "numero tentativi",
				en: "number of attempts"
			},
			indexQuery: 0,
			result: false,
			goodResultWidth: 0,
			badResultHeight: 0,
			gameOverWidth: 0,
			attemptsCounter: 0
		}
	},
	computed: {
		...mapGetters(['isMobile']),
		currentQuery() {
			return this.gameContents[this.indexQuery]
		},
		resultText() {
			return this.result ? this.$t('game_corretto') : this.$t('game_sbagliato') 
		},
		btnProceedText() {
			return this.result ? this.nextQueryText[this.$i18n.locale] : this.tryAgainText[this.$i18n.locale]
		},
		machiavelliImg() {
			return require('@assets/images/games/'+utils.manageImagesExtension('Portrait_of_Niccolò_Machiavelli.png'))
		},
		danteImg() {
			return require('@assets/images/games/'+utils.manageImagesExtension('AA_Dante_top_1.png'))
		},
		horseImg() {
			return require('@assets/images/games/'+utils.manageImagesExtension('horse.png'));
		}
	},
	watch: {
		async showOnlyIntro(n, o) {
			if(!n && o) {
				await nextTick();

				this.preliminaryOperationsOnAnimations();
			}
		}
	},
	methods: {
		async chooseAnswer(id) {
			this.gameContents[this.indexQuery].answers.find(a => a.id == id).selected = true
			this.attemptsCounter++
			await nextTick();
			await new Promise(resolve => setTimeout(resolve, 200));
			this.checkAnswer(id);
		},
		async checkAnswer(id) {
			this.showResultModal = true;
			let firstCheck = this.gameContents[this.indexQuery].answers.find(a => a.id == id).correct;
			if(firstCheck) {
				this.gameContents[this.indexQuery].resolved = true
			}else if(this.currentQuery.answers.filter(el => el.selected).length == 3) {
				// firstCheck = true
				// this.gameContents[this.indexQuery].answers.find(a => a.correct).selected = true
				// await nextTick();
			}

			this.result = firstCheck;

			await nextTick();
			await this.animateAnswer();
			// await new Promise(resolve => setTimeout(resolve, 1000));
			if(this.indexQuery < this.gameContents.length-1 || (!this.result && this.indexQuery == this.gameContents.length-1)) { // go to next question
				this.showProceedBtn = true
			}else if(this.result){ // GAME OVER
				console.log('GAME OVER')
				await this.disappearGoodResultModal();
				this.showGameOverModal = true;
				await this.animateGameOver();
				this.showRestartBtn = true;
			}
		},
		async animateAnswer() {
			let t = utils.createTimeline(1, {});
			if(this.result) {
				document.querySelector('.result-parenthesis.good-result .section-button-text').style.width = 0;
				document.querySelector('.full-answer-text').style.opacity = 0;
				t.to('.result-parenthesis.good-result', {top: '50%', duration: 0}, 0)
				this.$el.querySelector('.game-result-modal').style.zIndex = 2;
				t.to('.result-parenthesis.good-result .section-button-text', {width: this.goodResultWidth +'px', opacity: 1}, 0.5);
				t.to('.machiavelli-img, .dante-img', {opacity: 1, transform: 'translate(-100%, 0) rotate(0deg)', duration: 0}, 0)
				t.to('.machiavelli-img', {transform: 'translate(-5%, 0) rotate(13.3deg)'}, 0.5)
				if(this.currentQuery.fullAnswer[this.$i18n.locale].length) {
					t.to('.machiavelli-img', {opacity: 0, duration: 0.5}, 1.5)
					t.to('.result-parenthesis.good-result', {top: '15%'}, 1.5)
					t.to('.full-answer-text', {opacity: 1}, 2.5)
				}
			}else {
				document.querySelector('.result-parenthesis.wrong-result .section-button-text').style.height = 0;
				this.$el.querySelector('.game-result-modal').style.zIndex = 2;
				t.to('.full-answer-text', {opacity: 0, duration: 0}, 0)
				t.to('.result-parenthesis.wrong-result .section-button-text', {height: this.badResultHeight+'px', opacity: 1}, 0.5);
				t.to('.machiavelli-img, .dante-img', {opacity: 1, transform: 'translate(-100%, 0) rotate(0deg)', duration: 0}, 0)
				t.to('.dante-img', {transform: 'translate(-5%, 0)'}, 0.5)
			}
			t.play();
			return new Promise(resolve => t.eventCallback('onComplete', resolve))
		},
		async disappearGoodResultModal()  {
			let t = utils.createTimeline(0.5, {});
			t.to('.result-parenthesis.good-result', {opacity: 0}, 0);
			t.to('.full-answer-text', {opacity: 0}, 0);
			t.to('.machiavelli-img', {opacity: 0}, 0);
			t.play();
			return new Promise(resolve => t.eventCallback('onComplete', resolve))
		},	
		async animateGameOver() {
			let t = utils.createTimeline(1, {});
			document.querySelector('.result-parenthesis.game-over .section-button-text').style.width = 0;
			document.querySelector('.result-img.horse-img').style.transform = 'translate(-100%, 50%) rotate(0deg)';
			this.$el.querySelector('.game-result-modal.game-over').style.zIndex = 2;
			t.to('.result-parenthesis.game-over .section-button-text', {width: this.gameOverWidth +'px', opacity: 1}, 0.5);
			t.to('.game-attempts-text', {opacity: 1}, 1);
			t.to('.result-img.horse-img', {transform: 'translate(-10%, 50%) rotate(30deg)', duration: 0.5}, 0.5)
			t.to('.result-img.horse-img', {transform: 'translate(20%, 50%) rotate(-30deg)', duration: 0.5}, 0.5)
			t.play();
			return new Promise(resolve => t.eventCallback('onComplete', resolve))
		},
		async proceed() {

			this.showProceedBtn = false
			this.showResultModal = false
			await this.manageResultModalDisappear();
			if(this.currentQuery.resolved && this.indexQuery < this.gameContents.length-1) this.indexQuery++
		},
		// resetGame() {
		// 	this.myQuote = []
		// 	this.myTempQuote = []
		// 	// this.$el.querySelector('.game-result-modal').style.zIndex = -2;
		// 	// this.$el.querySelector('.game-quote-modal').style.zIndex = -2;
		// 	this.showResultModal = false
		// 	this.showOnlyIntro = false
		// },
		async resetGame() {
			console.log('restart game')
			this.showOnlyIntro = true;
			this.showResultModal = false
			this.showGameOverModal = false
			this.showProceedBtn = false
			this.showRestartBtn = false
			await nextTick();
			this.setGameContents();
		},

		exitGame() {
			this.resetGame();
			this.$emit('exit')
		},
		async manageResultModalDisappear() {
			return new Promise(resolve => {
				let me = this;
				let fun = function(e) {
					if(e.propertyName == 'opacity' && !me.showResultModal) {
						this.style.zIndex = -2
						resolve();
					}
				}
				this.$el.querySelector('.game-result-modal').removeEventListener('transitionend', fun)
				this.$el.querySelector('.game-result-modal').addEventListener('transitionend', fun)
			})
		},
		async preliminaryOperationsOnAnimations() {
			if(this.goodResultWidth !== 0) return
			let me = this;
			// close result parenthesis when the modal end disappear
			this.$el.querySelector('.game-result-modal').addEventListener('transitionend', function(e) {
				if(e.propertyName == 'opacity' && !me.showResultModal) this.style.zIndex = -2
			})
			// assing width and height parenthesis results's texts 
			this.result = false;
			this.badResultHeight = document.querySelector('.result-parenthesis.wrong-result h3').getBoundingClientRect().height
			this.result = true;
			await nextTick();
			this.goodResultWidth = document.querySelector('.result-parenthesis.good-result h3').getBoundingClientRect().width
			this.result = false
			await nextTick();

			this.gameOverWidth = document.querySelector('.result-parenthesis.game-over h3').getBoundingClientRect().width

			// inhubit propagation from modal to answers container
			this.$el.querySelector('.game-result-modal').removeEventListener('click', e => e.stopPropagation())
			this.$el.querySelector('.game-result-modal').addEventListener('click', e => e.stopPropagation())
			this.$el.querySelector('.game-result-modal').removeEventListener('touchstart', e => e.stopPropagation())
			this.$el.querySelector('.game-result-modal').addEventListener('touchstart', e => e.stopPropagation())
		},
		setGameContents() {
			this.attemptsCounter = 0;
			this.indexQuery = 0;
			if(this.$el.querySelector('.game-attempts-text')) this.$el.querySelector('.game-attempts-text').style.opacity = 0
			this.gameContents.forEach((g, i) => {
				this.gameContents[i].resolved = false;
				this.gameContents[i].id = i;
				this.gameContents[i].answers.forEach(a => {
					a.selected = false
				})
			})
		},
	},
	mounted() {
		this.setGameContents();
		// this.gameContents = shuffle(this.gameContents)
	}
}

</script>

<style lang="scss" scoped>

	@import "@css/components/gameStyle.scss";

</style>
